<template>
  <base-modal ref="modal">
    <base-card shadow>
      <h3 class="tw-text-xl tw-font-thin">Change Location</h3>
      <base-form ref="form" v-model="isFormValid" class="tw-mt-5">
        <base-select
          label="Change primary location"
          placeholder="Select a location"
          :optgroups="locationOptGroups"
          v-model="selectedLocationId"
          label-key="name"
          value-key="businessLocationId"
          required
          v-if="locations.length > 1"
        />
      </base-form>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="save" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" :disabled="!isFormValid">Save</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
      <inline-error id="change-business-member-plan-location-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>
<script>
import { mapGetters } from "vuex";
import InlineError from "@/components/InlineError";
import { STATE_OPTIONS } from "@/constants/constants";

export default {
  name: "BusinessMemberPlanChangeLocation",
  components: { InlineError },
  props: {
    businessId: String,
    userBusinessPlanId: String,
    businessLocationId: String,
  },
  data() {
    return {
      isLoading: false,
      errorTitle: "",
      errorMessage: "",
      error: null,
      selectedLocationId: null,
      isFormValid: true,
    };
  },
  computed: {
    ...mapGetters("location", ["locations"]),
    locationOptGroups() {
      return STATE_OPTIONS.filter((s) => this.locations.find((l) => l.state === s.value)).map((s) => ({
        label: s.value,
        options: this.locations.filter((l) => l.state === s.value),
      }));
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
      this.selectedLocationId = this.businessLocationId;
    },
    hide() {
      this.errorTitle = "";
      this.errorMessage = "";
      this.error = null;
      this.$refs.modal.hide();
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.isLoading = true;

      this.$axios
        .put(`/businesses/${this.businessId}/members/${this.userId}/memberplans/${this.userBusinessPlanId}/updateLocation/${this.selectedLocationId}`)
        .then(() => {
          this.hide();
          this.EventBus.$emit("member_update");
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Location Changed", message: "The user's plan location was changed successfully." });
        })
        .catch((err) => {
          this.errorTitle = `Sorry, the location change failed`;
          this.errorMessage = `We were not able to change the location of this plan. Please try again.`;
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
